import {
  Avatar,
  Grid,
  Link,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Popover,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import EmojiPeopleIcon from "@mui/icons-material/EmojiPeople";
import BarChartIcon from "@mui/icons-material/BarChart";
import AssistantPhotoIcon from "@mui/icons-material/AssistantPhoto";
import StarIcon from "@mui/icons-material/Star";
import AutoGraphIcon from "@mui/icons-material/AutoGraph";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { WordBarElement } from "../../../components/WordBarElement";
import { SentimentGauge } from "../../../components/SentimentGauge";
import BrowseGalleryIcon from "@mui/icons-material/BrowseGallery";
import PsychologyAltIcon from "@mui/icons-material/PsychologyAlt";
import neuralBackground from "../../../assets/neural-background-opaque.png";
import {
  sourcesToElements,
  sourcesToElementsWithDetail,
} from "../../../components/popup/ContentListPopup";
import CategoryIcon from "@mui/icons-material/Category";
import { singleField, sumByField } from "../../../util/ArrayUtil";
import { Chart, registerables } from "chart.js";
import { curveLineOptions } from "../../../util/ChartStyleUtil";
import { Line } from "react-chartjs-2";
import { useState } from "react";
import { ContentDetailPopup } from "../../../components/ContentDetailPopup";
import React from "react";
import { HighlightNumber } from "../../../components/HighlightNumber";
import NumberBox from "../../../components/NumberBox";
import RankingNumber from "../../../components/RankingNumber";
Chart.register(...registerables);
export function KeywordDetailPage(props: any) {
  const { t } = useTranslation(["common", "keyword", "sidebar"]);
  const [showNewsDetailPopup, setShowNewsDetailPopup] = useState(false);
  const [chosenNewsID, setChosenNewsID] = useState(0);
  var keywordDetail = props.keywordDetail;
  var appearancesOnTitleToday = keywordDetail.appearancesOnTitleToday
    ? keywordDetail.appearancesOnTitleToday
    : 0;
  var appearancesOnTitle = keywordDetail.appearancesOnTitle
    ? keywordDetail.appearancesOnTitle
    : 0;
  if (Object.keys(keywordDetail).length <= 0) {
    return <div></div>;
  }
  var summaries = props.keywordDetail.summary
    ? props.keywordDetail.summary
    : [];
  var summary = "";
  if (summaries.length > 0) {
    summary = summaries[0].summary;
  }
  var appearancesToday = keywordDetail.appearances
    ? singleField(keywordDetail.appearances, "count")[0]
    : 0;
  var appearancesThisWeek = keywordDetail.appearances
    ? sumByField(keywordDetail.appearances, "count")
    : 0;
  var averageTimeOnHeadlines = props.keywordDetail.averageTimeOnHeadlines
    ? props.keywordDetail.averageTimeOnHeadlines
    : 0;
  var recentNegatives = keywordDetail.recentNegatives
    ? keywordDetail.recentNegatives
    : [];
  var recentPositives = keywordDetail.recentPositives
    ? keywordDetail.recentPositives
    : [];
  var headlines = keywordDetail.longestTimeOnHeadlines
    ? keywordDetail.longestTimeOnHeadlines
    : [];
  var headlinesList = headlines.slice(0, 3).map((source: any) => {
    return (
      <ListItem
        alignItems="flex-start"
        className="grey-hover minor-scale-up-hover"
        onClick={() => {
          setChosenNewsID(source["id"]);
          setShowNewsDetailPopup(true);
        }}
      >
        <ListItemAvatar>
          <Avatar
            alt={source["source"]}
            src={
              "https://www.google.com/s2/favicons?domain=" +
              new URL(source["url"]).hostname +
              "/favicon.ico"
            }
          />
        </ListItemAvatar>
        <ListItemText
          style={{ textAlign: "justify" }}
          primary={source["title"]}
          primaryTypographyProps={{
            fontSize: "14px",
            color: "#1976d2",
            fontWeight: 500,
          }}
          secondaryTypographyProps={{
            fontSize: "12px",
          }}
          secondary={
            <React.Fragment>
              <Typography
                sx={{ display: "inline", fontSize: "12px" }}
                component="span"
                variant="body2"
                color="text.primary"
              >
                {source["author"]}
              </Typography>
              {(source["author"] ? " - " : "") + source["description"]}
            </React.Fragment>
          }
        />
      </ListItem>
    );
  });
  var recentPositiveList = recentPositives.slice(0, 3).map((source: any) => {
    return (
      <ListItem
        alignItems="flex-start"
        className="grey-hover minor-scale-up-hover"
        onClick={() => {
          setChosenNewsID(source["id"]);
          setShowNewsDetailPopup(true);
        }}
      >
        <ListItemAvatar>
          <Avatar
            alt={source["source"]}
            src={
              "https://www.google.com/s2/favicons?domain=" +
              new URL(source["url"]).hostname +
              "/favicon.ico"
            }
          />
        </ListItemAvatar>
        <ListItemText
          style={{ textAlign: "justify" }}
          primary={source["title"]}
          primaryTypographyProps={{
            fontSize: "14px",
            color: "#1976d2",
            fontWeight: 500,
          }}
          secondaryTypographyProps={{
            fontSize: "12px",
          }}
          secondary={
            <React.Fragment>
              <Typography
                sx={{ display: "inline", fontSize: "12px" }}
                component="span"
                variant="body2"
                color="text.primary"
              >
                {source["author"]}
              </Typography>
              {(source["author"] ? " - " : "") + source["description"]}
            </React.Fragment>
          }
        />
      </ListItem>
    );
  });
  var recentNegativeList = recentNegatives.slice(0, 3).map((source: any) => {
    return (
      <ListItem
        alignItems="flex-start"
        className="grey-hover minor-scale-up-hover"
        onClick={() => {
          setChosenNewsID(source["id"]);
          setShowNewsDetailPopup(true);
        }}
      >
        <ListItemAvatar>
          <Avatar
            alt={source["source"]}
            src={
              "https://www.google.com/s2/favicons?domain=" +
              new URL(source["url"]).hostname +
              "/favicon.ico"
            }
          />
        </ListItemAvatar>
        <ListItemText
          style={{ textAlign: "justify" }}
          primary={source["title"]}
          primaryTypographyProps={{
            fontSize: "14px",
            color: "#1976d2",
            fontWeight: 500,
          }}
          secondaryTypographyProps={{
            fontSize: "12px",
          }}
          secondary={
            <React.Fragment>
              <Typography
                sx={{ display: "inline", fontSize: "12px" }}
                component="span"
                variant="body2"
                color="text.primary"
              >
                {source["author"]}
              </Typography>
              {(source["author"] ? " - " : "") + source["description"]}
            </React.Fragment>
          }
        />
      </ListItem>
    );
  });
  var relatedTopics = keywordDetail.relatedTopics
    ? keywordDetail.relatedTopics.sort((a: any, b: any) => {
        return b.points - a.points;
      })
    : [];
  var relatedAdjectives =
    keywordDetail.relatedAdjectives.length &&
    keywordDetail.relatedAdjectives.length > 0
      ? keywordDetail.relatedAdjectives.sort((a: any, b: any) => {
          return b.count - a.count;
        })
      : [];
  var relatedKeywords =
    keywordDetail.relatedKeywords.length &&
    keywordDetail.relatedKeywords.length > 0
      ? keywordDetail.relatedKeywords.sort((a: any, b: any) => {
          return b.count - a.count;
        })
      : [];
  var relatedKeywordList = relatedKeywords.slice(0, 5).map((keyword: any) => {
    var barLength = (keyword.count / relatedKeywords[0].count) * 100;
    return (
      <WordBarElement
        word={keyword.keyword}
        scaledNumber={barLength}
        icon={
          <AddCircleIcon
            color={
              keyword.keyword == relatedKeywords[0].keyword
                ? "error"
                : "success"
            }
          />
        }
        color={
          keyword.keyword == relatedKeywords[0].keyword ? "error" : "success"
        }
      />
    );
  });
  var relatedAdjectiveList = relatedAdjectives
    .slice(0, 5)
    .map((keyword: any) => {
      var barLength = (keyword.count / relatedAdjectives[0].count) * 100;
      return (
        <WordBarElement
          word={keyword.keyword}
          scaledNumber={barLength}
          icon={<PsychologyAltIcon color={"warning"} />}
          color={"info"}
        />
      );
    });
  var relatedTopicsList = relatedTopics.slice(0, 5).map((topic: any) => {
    var barLength = (topic.points / relatedTopics[0].points) * 100;
    return (
      <WordBarElement
        word={topic.topic}
        scaledNumber={barLength}
        icon={<CategoryIcon color={"error"} />}
        color={"secondary"}
      />
    );
  });

  const dataLineChart = {
    labels: singleField(keywordDetail.appearances, "day").slice(-5),
    datasets: [
      {
        data: singleField(keywordDetail.appearances, "count").slice(-5),
        label: "Số lần được nhắc đến",
        fill: true,
        backgroundColor: "rgba(75,192,192,0.2)",
        borderColor: "rgba(75,192,192,1)",
      },
    ],
  };
  const options = curveLineOptions();
  options.scales = {
    display: false,
    x: {
      min: 0,
      grid: {
        display: false,
      },
    },
    y: {
      min: 0,
      grid: {
        display: false,
      },
    },
  };
  options.plugins.legend.display = false;

  return (
    <Grid
      container
      xs={12}
      spacing={2}
      marginTop={1.5}
      style={{ backgroundImage: `url(${neuralBackground})`, marginLeft: "0px" }}
    >
      <ContentDetailPopup
        id={chosenNewsID}
        popup={showNewsDetailPopup}
        onClosePopup={() => {
          setShowNewsDetailPopup(false);
          setChosenNewsID(0);
        }}
      />
      <Typography
        style={{ width: "100%", textAlign: "center" }}
        marginTop={2}
        variant="h4"
        fontWeight={600}
      >
        {t("sidebar:overview") +
          " " +
          t("common:about") +
          " " +
          t("sidebar:keyword").toLowerCase() +
          " '" +
          props.keyword +
          "'"}
      </Typography>
      <Grid container xs={12} spacing={0} marginTop={3}>
        <Grid item xs={0.5}></Grid>
        <Grid
          item
          xs={3.5}
          className="grid-border white"
          textAlign={"center"}
          padding={2}
        >
          <NumberBox
            title={t("keyword:average_headline_time")}
            variant={"h3"}
            number={
              Math.round(averageTimeOnHeadlines) + " " + t("common:minutes")
            }
            icon={
              <BrowseGalleryIcon
                sx={{ width: "40px", height: "40px", color: "#81d4fa" }}
              />
            }
            subtitle={t("common:derived_from_this_week")}
          />
        </Grid>
        <Grid item xs={0.25}></Grid>
        <Grid
          item
          xs={3.5}
          padding={2}
          className="grid-border white"
          textAlign={"center"}
        >
          <NumberBox
            title={t("keyword:appearances_today")}
            variant={"h3"}
            number={appearancesToday}
            icon={
              <EmojiPeopleIcon
                color="warning"
                sx={{ width: "40px", height: "40px" }}
              />
            }
            subtitle={t("common:derived_from_today")}
          />
        </Grid>
        <Grid item xs={0.25}></Grid>
        <Grid
          item
          xs={3.5}
          padding={2}
          className="grid-border white"
          textAlign={"center"}
        >
          <NumberBox
            title={t("keyword:appearances_week")}
            number={appearancesThisWeek}
            variant={"h3"}
            icon={
              <AutoGraphIcon
                color="success"
                sx={{ width: "40px", height: "40px" }}
              />
            }
            subtitle={t("common:derived_from_this_week")}
          />
        </Grid>
        <Grid item xs={0.5}></Grid>
      </Grid>
      <Grid container xs={12} spacing={0} marginTop={4}>
        <Grid item xs={0.5}></Grid>
        <Grid item xs={3.5} padding={2} className="grid-border white">
          <Typography
            variant="h6"
            align="center"
            fontWeight={600}
            marginBottom={6}
          >
            {t("common:overall_sentiment") + " " + t("common:today")}
          </Typography>
          <SentimentGauge
            minHeight={20}
            sentiment={keywordDetail.overallSentiment}
          ></SentimentGauge>
        </Grid>
        <Grid item xs={0.25}></Grid>
        <Grid
          item
          xs={3.5}
          padding={2}
          className="grid-border white"
          textAlign={"center"}
        >
          <RankingNumber
            number={
              keywordDetail.rankingToday ? keywordDetail.rankingToday : 100000
            }
            title={t("keyword:ranking_based_on_popularity")}
            subtitle={t("common:derived_from_today")}
            variant={"h3"}
          />
          <div style={{ marginTop: "20px" }}></div>
          <RankingNumber
            number={
              keywordDetail.appearanceRankingToday
                ? keywordDetail.appearanceRankingToday
                : 100000
            }
            title={t("keyword:ranking_based_on_appearances")}
            subtitle={t("common:derived_from_this_week")}
            variant={"h3"}
          />
        </Grid>
        <Grid item xs={0.25}></Grid>
        <Grid item xs={3.5} padding={2} className="grid-border white">
          <Typography variant="h6" align="center" fontWeight={600}>
            {t("keyword:frequency_of_appearance")}
          </Typography>
          <Line height={120} data={dataLineChart} options={options}></Line>
        </Grid>
        <Grid item xs={0.5}></Grid>
      </Grid>
      <Grid container xs={12} spacing={0} marginTop={4}>
        <Grid item xs={0.5}></Grid>
        <Grid
          item
          xs={3.5}
          className="grid-border white"
          textAlign={"center"}
          padding={2}
        >
          <NumberBox
            title={t("keyword:appearances_on_title")}
            variant={"h3"}
            number={Math.round(appearancesOnTitleToday)}
            icon={
              <AssistantPhotoIcon
                color="success"
                sx={{ width: "40px", height: "40px" }}
              />
            }
            subtitle={t("common:derived_from_today")}
          />
        </Grid>
        <Grid item xs={0.25}></Grid>
        <Grid
          item
          xs={3.5}
          padding={2}
          className="grid-border white"
          textAlign={"center"}
        >
          <NumberBox
            title={t("keyword:appearances_on_title")}
            variant={"h3"}
            number={Math.round(appearancesOnTitle)}
            icon={
              <StarIcon
                color="warning"
                sx={{ width: "40px", height: "40px" }}
              />
            }
            subtitle={t("common:derived_from_this_week")}
          />
        </Grid>
        <Grid item xs={0.25}></Grid>
        <Grid
          item
          xs={3.5}
          padding={2}
          className="grid-border white"
          textAlign={"center"}
        >
          <NumberBox
            title={t("keyword:appearances_on_title_ratio")}
            number={
              Math.round(
                (appearancesOnTitle
                  ? appearancesOnTitle / appearancesThisWeek
                  : 0) * 100
              ) + "%"
            }
            variant={"h3"}
            icon={
              <BarChartIcon
                color="error"
                sx={{ width: "40px", height: "40px" }}
              />
            }
            subtitle={t("common:derived_from_this_week")}
          />
        </Grid>
        <Grid item xs={0.5}></Grid>
      </Grid>
      <Grid container xs={12} spacing={0} marginTop={4}>
        <Grid item xs={0.5}></Grid>
        <Grid item xs={3.5} padding={2} className="grid-border white">
          <Typography
            variant="h6"
            align="center"
            marginLeft={"15px"}
            fontWeight={600}
          >
            {t("keyword:related_keywords")}
          </Typography>
          <List sx={{ padding: "0px" }}>{relatedKeywordList}</List>
        </Grid>
        <Grid item xs={0.25}></Grid>
        <Grid item xs={3.5} padding={2} className="grid-border white">
          <Typography
            variant="h6"
            align="center"
            marginLeft={"15px"}
            fontWeight={600}
          >
            {t("keyword:related_adjectives")}
          </Typography>
          <List sx={{ padding: "0px" }}>{relatedAdjectiveList}</List>
        </Grid>
        <Grid item xs={0.25}></Grid>
        <Grid item xs={3.5} padding={2} className="grid-border white">
          <Typography
            variant="h6"
            align="center"
            marginLeft={"15px"}
            fontWeight={600}
          >
            {t("keyword:related_topics")}
          </Typography>
          <List sx={{ padding: "0px" }}>{relatedTopicsList}</List>
        </Grid>
        <Grid item xs={0.5}></Grid>
      </Grid>
      <Grid container xs={12} spacing={0} marginTop={4}>
        <Grid item xs={0.5}></Grid>
        <Grid item xs={3.5} padding={2} className="grid-border white">
          <Typography variant="h6" align="center" fontWeight={600}>
            {t("keyword:headlines")}
          </Typography>
          <List>{headlinesList}</List>
        </Grid>
        <Grid item xs={0.25}></Grid>
        <Grid item xs={3.5} padding={2} className="grid-border white">
          <Typography variant="h6" align="center" fontWeight={600}>
            {t("keyword:recent_positive_articles")}
          </Typography>
          <List>{recentPositiveList}</List>
        </Grid>
        <Grid item xs={0.25}></Grid>
        <Grid item xs={3.5} padding={2} className="grid-border white">
          <Typography variant="h6" align="center" fontWeight={600}>
            {t("keyword:recent_negative_articles")}
          </Typography>
          <List>{recentNegativeList}</List>
        </Grid>
        <Grid item xs={0.5}></Grid>
      </Grid>
    </Grid>
  );
}

export function KeywordDetailPopup(props: any) {
  var keywordDetail = props.keywordDetail;

  if (Object.keys(keywordDetail).length <= 0) {
    return <div></div>;
  }

  return (
    <Popover
      open={props.open}
      onClose={props.onClose}
      anchorOrigin={{
        vertical: "center",
        horizontal: "right",
      }}
      sx={{
        marginTop: "25px",
        minWidth: "70vw",
        minHeight: "100vh",
      }}
    >
      <KeywordDetailPage
        keywordDetail={keywordDetail}
        keyword={props.keyword}
      />
    </Popover>
  );
}
